module.exports = __webpack_public_path__ + "img/mmi.7a1e6f27.png";